module.exports = __webpack_public_path__ + "img/DSCN2033.c4ddcf70.jpg";